import { Box, Stack, Text, VStack } from '@genial/components';
import { Color } from '@genial/design-tokens';
import React from 'react';
import { ActivityIndicator, Dimensions } from 'react-native';

interface StepLoadingProps {
  isMobile: boolean;
}

export const StepLoading: React.FC<StepLoadingProps> = ({ isMobile }) => {
  const { height: windowHeight } = Dimensions.get('window');
  return (
    <Stack flex={1} alignItems="center" justifyContent="center">
      <Box
        flexDirection={isMobile ? 'column' : 'row'}
        paddingX="stack.xxxs"
        pt={(windowHeight / 2) * 0.8}
        alignItems="center">
        <ActivityIndicator size={'large'} color={Color['neutral.medium']} />
        <VStack
          flex={1}
          paddingTop={isMobile ? 'stack.xxxs' : 0}
          paddingLeft="stack.xxxs"
          space="stack.quarck">
          <Text variant="semibold" fontSize="lg">
            Aguarde enquanto estamos processando sua solicitação.
          </Text>
          <Text fontSize="md">
            Este processo pode levar alguns segundos, não saia desta página.
          </Text>
        </VStack>
      </Box>
    </Stack>
  );
};
